document.addEventListener('DOMContentLoaded', function() {
  console.log("recommendation-block.js geladen: Starte Verarbeitung.");

  // 1) Zentrale Werte definieren
  const productLinkValue     = "https://naturmacher.de/products/sprachtopf-blumentopf-mit-deiner-stimme?variant=53193558884619";
  const productImageValue    = "https://naturmacher.de/cdn/shop/files/88d3f25551ab1acfb39b290fdd509697.png?v=1782388982";
  const productTitleValue    = "Jetzt personalisieren";
  const productHeadingValue  = "Ein Geschenk, das sprechen kann";
  const productPriceValue    = "an 36,99€";
  const productInfoLabelValue   = "";
  const productInfoTooltipValue = "🎁 Mit Code: Topf10 – Schnell sein lohnt sich! 🎁";
 // const productInfoTooltipValue = "Dies ist ein Affiliate-Link. Solltest du das Produkt über diesen Link kaufen, erhalte ich eine kleine Provision. Für dich entstehen dadurch keine Nachteile.";

  // 2) Alle Blocks durchgehen:
  document.querySelectorAll('.recommendation-block').forEach(function(block, index) {
  // console.log(`===> Verarbeite Block #${index} <===`);

    // 3) Platzhalter-Werte auslesen
    let linkAttr    = block.getAttribute('data-product-link');
    let imgAttr     = block.getAttribute('data-product-image');
    let titleAttr   = block.getAttribute('data-product-title');
    let headingAttr = block.getAttribute('data-product-heading');
    let priceAttr   = block.getAttribute('data-product-price');
    let labelAttr   = block.getAttribute('data-info-label');
    let tooltipAttr = block.getAttribute('data-info-tooltip'); // NEU

  //  console.log("Vorher tooltipAttr =", tooltipAttr);

    // 4) Platzhalter checken & überschreiben
    if (linkAttr === '[[hier_kann_dein_produkt_stehen]]') {
      block.setAttribute('data-product-link', productLinkValue);
    }
    if (imgAttr === '[[hier_kann_bild_produkt_stehen]]') {
      block.setAttribute('data-product-image', productImageValue);
    }
    if (titleAttr === '[[hier_kann_text_produkt_stehen]]') {
      block.setAttribute('data-product-title', productTitleValue);
    }
    if (headingAttr === '[[hier_kann_ueberschrift_stehen]]') {
      block.setAttribute('data-product-heading', productHeadingValue);
    }
    if (priceAttr === '[[hier_kann_preis_stehen]]') {
      block.setAttribute('data-product-price', productPriceValue);
    }
    if (labelAttr === '[[hier_kann_info_label_stehen]]') {
      block.setAttribute('data-info-label', productInfoLabelValue);
    }
    // NEU: Tooltip
    if (tooltipAttr === '[[hier_kann_tooltip_stehen]]') {
      block.setAttribute('data-info-tooltip', productInfoTooltipValue);
    }

    // 5) Finalen Wert nochmal auslesen
    const finalLink    = block.getAttribute('data-product-link');
    const finalImage   = block.getAttribute('data-product-image');
    const finalTitle   = block.getAttribute('data-product-title');
    const finalHeading = block.getAttribute('data-product-heading');
    const finalPrice   = block.getAttribute('data-product-price');
    const finalLabel   = block.getAttribute('data-info-label');
    const finalTooltip = block.getAttribute('data-info-tooltip');  // NEU

    //console.log("Nachher finalTooltip =", finalTooltip);

    // 6) Nun in die Elemente eintragen
    const linkElement   = block.querySelector('.product-link');
    const imgElement    = block.querySelector('.product-image');
    const titleElement  = block.querySelector('.product-title');
    const headingEl     = block.querySelector('h3');
    const priceElement  = block.querySelector('.product-price');
    const labelElement  = block.querySelector('.info-label');
    const tooltipEl     = block.querySelector('.info-tooltip');

    if (linkElement)   linkElement.href = finalLink;
    if (imgElement)    imgElement.src  = finalImage;
    if (titleElement)  titleElement.innerText  = finalTitle;
    if (headingEl)     headingEl.innerText     = finalHeading;
    if (priceElement)  priceElement.innerText  = finalPrice;

    // info-label
    if (labelElement) {
      labelElement.innerText = finalLabel;
      //console.log("labelElement gesetzt auf:", finalLabel);
    }

    // info-tooltip
    if (tooltipEl) {
      tooltipEl.innerText = finalTooltip;
      //console.log("tooltipEl gesetzt auf:", finalTooltip);
    }

    // 7) Tooltip-Effekt (Mouseover/Mouseout)
    block.addEventListener('mouseover', function() {
      if (tooltipEl) tooltipEl.style.display = 'block';
    });
    block.addEventListener('mouseout', function() {
      if (tooltipEl) tooltipEl.style.display = 'none';
    });
  });
});
